import { useRef, useState, type ReactNode } from 'react';
import type { QuestionBankBrowseStyles } from './questionBankBrowseStyles';

export interface QuestionBankFilterSelectProps {
  styles: QuestionBankBrowseStyles['browse'];
  name: string;
  value: string;
  onChange: (value: string) => void;
  /** The page's smaller, squarer "Sort by" box instead of the Type and Purpose pill. */
  quiet?: boolean;
  children: ReactNode;
}

/**
 * A filter pill whose select shows a focus ring only for keyboard focus.
 * Chrome keeps a select focused after a mouse pick and draws its ring, which
 * read as a stray blue box after every selection (PO, 2026-11-03).
 */
export function QuestionBankFilterSelect({ styles, name, value, onChange, quiet = false, children }: QuestionBankFilterSelectProps) {
  const pointer = useRef(false);
  const [ring, setRing] = useState(false);
  return (
    <label style={{ ...(quiet ? styles.sortPill : styles.fieldPill), ...(ring ? styles.fieldPillFocused : {}) }}>
      <span style={styles.fieldName}>{`${name}:`}</span>
      <select
        aria-label={name}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        onMouseDown={() => { pointer.current = true; setRing(false); }}
        onFocus={() => { setRing(!pointer.current); pointer.current = false; }}
        onKeyDown={() => setRing(true)}
        onBlur={() => { setRing(false); pointer.current = false; }}
        style={quiet ? styles.sortSelect : styles.fieldSelect}
      >
        {children}
      </select>
    </label>
  );
}
